const FavouritesDashboardActionTypes = {
    ADD_SELECTION: 'ADD_SELECTION',
    REMOVE_SELECTION: 'REMOVE_SELECTION',

    CLOSE_SECTIONS_SIDE_NAV: 'CLOSE_SECTIONS_SIDE_NAV',

    ADD_ASSET_TO_FAVOURITES: 'ADD_ASSET_TO_FAVOURITES',
    REMOVE_ASSET_FROM_FAVOURITES: 'REMOVE_ASSET_FROM_FAVOURITES',
    REMOVE_MULTIPLE_ASSETS_FROM_FAVOURITES: 'REMOVE_MULTIPLE_ASSETS_FROM_FAVOURITES',

    START_FETCH_ALL_FAVOURITES: 'START_FETCH_ALL_FAVOURITES',
    SUCCESS_FETCH_ALL_FAVOURITES: 'SUCCESS_FETCH_ALL_FAVOURITES',
    FAILURE_FETCH_ALL_FAVOURITES: 'FAILURE_FETCH_ALL_FAVOURITES',

    CLEAR_SELECTED_ASSETS: 'CLEAR_SELECTED_ASSETS',
}

export default FavouritesDashboardActionTypes
